module.exports = __webpack_public_path__ + "static/icon_milano_centro_grigio-d20792745b4c45cf4c6a7032aae7f61f.svg";